
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Vimannagartomumbaiertigaonrent() {



    const cardData =
    {
        keyword: ' Viman Nagar to Mumbai Ertiga On Rent',
        heading: 'Prince Cabs: Viman Nagar to Mumbai Ertiga On Rent',
        headingDescription: 'Prince Cabs offers comfortable Viman Nagar to Mumbai Ertiga on Rent, perfect for airport transfers, family trips, business travel, and outstation journeys. Our spacious and well-maintained Ertiga vehicles provide a safe, reliable, and budget-friendly ride from Viman Nagar to Mumbai via the expressway. With professional chauffeurs, on-time pickups, and flexible booking options, we make your travel smooth and hassle-free. Choose Prince Cabs’ trusted Ertiga rental service from Viman Nagar to Mumbai for convenience, comfort, and affordability.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. It is a lively hub for tourists, photographers, and ferry rides to Elephanta Caves. The arch glows beautifully during sunset and night illumination. Surrounded by street vendors and heritage hotels, it always buzzes with activity. Gateway of India remains the proud symbol of Mumbai."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km long seafront boulevard. At night, its streetlights resemble a sparkling necklace, creating a magical view. Locals and tourists love it for jogging, evening strolls, and sea-facing relaxation. During monsoon, waves dramatically crash against the promenade. Sunsets here are breathtaking and romantic. Marine Drive perfectly reflects Mumbai’s modern lifestyle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. It is a Gothic Revival masterpiece with domes, stained-glass windows, and intricate carvings. The station serves as Mumbai’s busiest commuter hub. At night, its illuminated façade looks spectacular. Tourists admire its architectural grandeur while witnessing the city’s lifeline—the local trains. CST is Mumbai’s finest heritage landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, a UNESCO World Heritage Site, are rock-cut temples located on Elephanta Island. Dating back to the 5th–6th centuries, they showcase exquisite sculptures of Lord Shiva, including the majestic Trimurti. The ferry ride from Gateway of India adds to the charm. Surrounded by greenery, the island offers peace away from city crowds. The caves highlight India’s ancient artistry and spirituality. Elephanta is a must-visit for history enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside attraction, famous for its street food and vibrant atmosphere. Visitors enjoy pav bhaji, bhel puri, and ice gola while strolling along the sandy shore. Families, couples, and children gather here in the evenings. Bollywood celebrities often reside nearby, making it a hotspot for star spotting. Sunsets here are magical and picturesque. Juhu Beach is Mumbai’s coastal heart."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it draws thousands of devotees daily, including celebrities and politicians. The temple’s golden dome and beautifully carved wooden doors add grandeur. Tuesdays witness massive crowds for special darshan. Devotees believe prayers here are always fulfilled. Siddhivinayak is the spiritual soul of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a modern engineering marvel that connects South Mumbai with the suburbs. This eight-lane cable-stayed bridge offers panoramic sea and skyline views. Driving across it, especially at night when illuminated, is a thrilling experience. It has significantly reduced travel time for commuters. The Sea Link combines functionality with beauty. It is Mumbai’s modern-day icon of progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a famous mosque located on an islet in the Arabian Sea. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts devotees of all faiths. The Indo-Islamic architecture stands strikingly against the sea. Accessible by a narrow causeway during low tide, the journey itself is spiritual. The shrine exudes peace and blessings. Haji Ali is Mumbai’s landmark of faith and devotion."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most bustling shopping street, lined with shops and vendors. Visitors buy clothes, jewelry, handicrafts, and antiques at affordable prices. Iconic cafés like Leopold Café and Café Mondegar add to its lively vibe. Bargaining is part of the shopping fun here. The market is always busy with both tourists and locals. Colaba Causeway reflects Mumbai’s cosmopolitan charm."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan festivities. Families love enjoying local snacks like pav bhaji, kulfi, and chaat here. The beach becomes especially vibrant during festivals and fairs. It offers stunning views of Marine Drive and the Arabian Sea. Children enjoy playing in the sand and waves. Chowpatty is Mumbai’s cultural and leisure hotspot."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread across 500 acres. It houses multiple studios, artificial sets, and shooting zones. Visitors can take guided tours to witness behind-the-scenes of movie-making. Cinema enthusiasts often spot live shoots here. It is one of the largest film production centers in the world. Film City defines Mumbai as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves showcase Buddhist rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such biodiversity in a metro city. The park is a mix of history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a picturesque artificial lake surrounded by greenery and skyscrapers. Birdwatchers often spot herons, kingfishers, and migratory birds here. The lakeside promenade is popular for jogging, cycling, and photography. During monsoon, the misty views enhance its beauty. Families enjoy picnics and relaxing walks nearby. Powai Lake is Mumbai’s peaceful natural retreat."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the largest meditation domes in the world. Built in Burmese style, it houses sacred relics of Buddha. The golden dome can accommodate thousands of meditators at once. Visitors attend meditation sessions and admire its grand design. Its seaside setting enhances serenity and peace. The pagoda is Mumbai’s global symbol of mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is Mumbai’s hub for astronomy and science education. It features immersive sky shows that explain stars, galaxies, and cosmic wonders. The adjoining Science Centre has interactive exhibits on technology and innovation. Families and students enjoy the mix of fun and learning. Special events are hosted during eclipses and celestial phenomena. It inspires curiosity and exploration among young minds."
  }
],


      "services": [
    {
      "name": "Viman Nagar to Mumbai Ertiga Taxi",
      "description": "Book reliable and comfortable Ertiga taxi services from Viman Nagar to Mumbai, offering spacious seating, professional drivers, and timely pickups for a smooth intercity journey."
    },
    {
      "name": "Ertiga Rental Viman Nagar to Mumbai",
      "description": "Rent an Ertiga for travel between Viman Nagar and Mumbai with flexible rental options, allowing you to choose your pickup times and vehicle usage according to your convenience."
    },
    {
      "name": "7 Seater Ertiga Cab Viman Nagar",
      "description": "Travel with family or friends in a spacious 7-seater Ertiga cab from Viman Nagar to Mumbai, offering ample legroom and luggage space for group comfort."
    },
    {
      "name": "Ertiga One Way Viman Nagar to Mumbai",
      "description": "Book an affordable and efficient one-way Ertiga cab from Viman Nagar to Mumbai, perfect for travelers who require drop services without a return journey."
    },
    {
      "name": "Viman Nagar to Mumbai Outstation Ertiga",
      "description": "Choose our outstation Ertiga service for a hassle-free trip from Viman Nagar to Mumbai, with experienced drivers ensuring a safe and pleasant travel experience."
    },
    {
      "name": "Viman Nagar to Mumbai Round Trip Ertiga",
      "description": "Plan your round-trip travel between Viman Nagar and Mumbai with our Ertiga cab service, including waiting time at Mumbai and flexible return schedules."
    },
    {
      "name": "Crysta Ertiga Viman Nagar to Mumbai",
      "description": "Upgrade your journey with a premium Crysta Ertiga from Viman Nagar to Mumbai, offering enhanced comfort, superior interiors, and smooth driving experience."
    },
    {
      "name": "Viman Nagar to Mumbai Family Ertiga Cab",
      "description": "Ideal for family travel, our Ertiga cabs from Viman Nagar to Mumbai come equipped with safety features and spacious interiors, making your trip comfortable and secure."
    },
    {
      "name": "Ertiga for Airport Drop Viman Nagar",
      "description": "Get timely and reliable airport drop service in an Ertiga from Viman Nagar to Mumbai airport, with driver assistance for luggage and real-time tracking."
    },
    {
      "name": "Viman Nagar to Mumbai Wedding Ertiga",
      "description": "Choose our specially arranged Ertiga cabs for wedding travel from Viman Nagar to Mumbai, ensuring spacious seating and elegant interiors for your special day."
    },
    {
      "name": "Affordable Ertiga Viman Nagar to Mumbai",
      "description": "Experience budget-friendly Ertiga cab services from Viman Nagar to Mumbai without compromising on quality, comfort, or safety."
    },
    {
      "name": "Viman Nagar to Mumbai AC Ertiga Rental",
      "description": "Enjoy a cool and comfortable journey with air-conditioned Ertiga rentals from Viman Nagar to Mumbai, perfect for beating the heat during your travel."
    },
    {
      "name": "Viman Nagar to Mumbai Tour Cab Ertiga",
      "description": "Explore Mumbai and surrounding areas with our tour cab services using Ertiga from Viman Nagar, featuring flexible itineraries and experienced drivers."
    },
    {
      "name": "Comfortable Ertiga Cab Viman Nagar to Mumbai",
      "description": "Travel comfortably between Viman Nagar and Mumbai in our well-maintained Ertiga cabs, designed for smooth rides and passenger convenience."
    },
    {
      "name": "SUV Ertiga Rental Viman Nagar",
      "description": "Opt for SUV-style Ertiga rentals from Viman Nagar, combining robust performance with spacious interiors for a premium travel experience to Mumbai."
    }
  ],
  "tableData": [
    ["Viman Nagar to Mumbai Ertiga Taxi", "Ertiga Rental Viman Nagar to Mumbai"],
    ["7 Seater Ertiga Cab Viman Nagar", "Ertiga One Way Viman Nagar to Mumbai"],
    ["Viman Nagar to Mumbai Outstation Ertiga", "Viman Nagar to Mumbai Round Trip Ertiga"],
    ["Crysta Ertiga Viman Nagar to Mumbai", "Viman Nagar to Mumbai Family Ertiga Cab"],
    ["Ertiga for Airport Drop Viman Nagar", "Viman Nagar to Mumbai Wedding Ertiga"],
    ["Affordable Ertiga Viman Nagar to Mumbai", "Viman Nagar to Mumbai AC Ertiga Rental"],
    ["Viman Nagar to Mumbai Tour Cab Ertiga", "Comfortable Ertiga Cab Viman Nagar to Mumbai"],
    ["SUV Ertiga Rental Viman Nagar"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Ertiga on Rent from Viman Nagar to Mumbai",
    "WhyChoosedescription": "Prince Cabs offers dependable Ertiga rental services for comfortable travel from Viman Nagar, Pune to Mumbai. Whether you’re heading to the airport, attending a business meeting, or planning a family visit, our service ensures safe, timely, and comfortable travel with door-to-door pickup and drop."
  },
  {
    "WhyChooseheading": "Spacious 7-Seater Ideal for Families and Groups",
    "WhyChoosedescription": "The Maruti Suzuki Ertiga is a practical 7-seater MPV, offering ample space for 6 passengers plus the driver. With comfortable seating, powerful air conditioning, and generous luggage space, it's a perfect choice for group travel from Viman Nagar to Mumbai—ideal for long highway rides."
  },
  {
    "WhyChooseheading": "Flexible One-Way and Round Trip Options",
    "WhyChoosedescription": "Prince Cabs provides highly flexible rental plans including one-way drops, round trips, and multi-day bookings. Whether you need the cab just to reach Mumbai or for return and intercity travel, we tailor the package to your needs with simple, upfront pricing and no last-minute surprises."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Expertise",
    "WhyChoosedescription": "Our drivers are trained, experienced, and well-acquainted with the Viman Nagar to Mumbai route. They ensure safe driving practices, smart navigation through expressways and traffic, and planned rest stops, offering you a smooth and stress-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent Fare Structure with No Hidden Charges",
    "WhyChoosedescription": "We provide upfront and honest pricing that includes fuel, tolls, driver allowance, and taxes. No hidden charges—what we quote is what you pay. You can make payments via UPI, credit/debit cards, net banking, or cash, based on your convenience."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety and comfort are our priority. Every Ertiga is sanitized before each trip and regularly serviced to ensure a clean, smooth, and reliable ride. Our vehicles are equipped with modern safety features including airbags, ABS, and seat belts for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Booking Assistance",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, schedule changes, or any queries. Whether you're booking a ride during the day or late at night, we ensure complete support for your Viman Nagar to Mumbai travel."
  }
]
























    }

const faqData = [
    {
        question: 'Can I rent an Ertiga from Viman Nagar to Mumbai with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers comfortable and spacious Ertiga rentals for travel from Viman Nagar, Pune to Mumbai with experienced drivers.',
    },
    {
        question: 'Is Ertiga suitable for long-distance travel like Viman Nagar to Mumbai?',
        answer: 'Absolutely! Ertiga is ideal for intercity journeys, offering ample legroom and luggage space for families and small groups.',
    },
    {
        question: 'Are the Ertiga cabs sanitized and well-maintained?',
        answer: 'Yes, all our vehicles including Ertiga are regularly cleaned, sanitized, and serviced for a safe and pleasant ride.',
    },
    {
        question: 'Does the Ertiga rental include a professional driver?',
        answer: 'Yes, our Ertiga rentals come with well-trained, courteous drivers who ensure a smooth and punctual journey.',
    },
    {
        question: 'What is the fare for renting an Ertiga from Viman Nagar to Mumbai?',
        answer: 'The fare depends on travel type (one-way or round trip), distance, and timing. Contact Prince Cabs for a customized quote.',
    },
    {
        question: 'Can I book a round trip from Viman Nagar to Mumbai in an Ertiga?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip rental options with Ertiga for Viman Nagar to Mumbai travel.',
    },
    {
        question: 'How can I book an Ertiga cab from Viman Nagar to Mumbai?',
        answer: 'You can book easily via our website or by contacting our customer support team for fast and reliable booking assistance.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajesh Thakur",
        position: "Frequent Traveler",
        text: "Booked an Ertiga from Viman Nagar to Mumbai with Prince Cabs. The ride was smooth and the driver was extremely professional.",
        image: "/img/testimonial/testimonial-thumb-vimannagar-mumbai-1.png",
    },
    {
        name: "Mrs. Anuja Kale",
        position: "Family Traveler",
        text: "Our trip from Viman Nagar to Mumbai in an Ertiga was comfortable and timely. Prince Cabs delivered excellent service.",
        image: "/img/testimonial/testimonial-thumb-vimannagar-mumbai-2.png",
    },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Viman Nagar to Mumbai Ertiga On Rent",
  "description": "Book Viman Nagar to Mumbai Ertiga taxi services including one way, round trip, family cab, airport drop, wedding trips, and affordable AC Ertiga rental.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "areaServed": [
    {
      "@type": "Place",
      "name": "Viman Nagar"
    },
    {
      "@type": "Place",
      "name": "Mumbai"
    }
  ],
  "serviceType": [
    "7 Seater Ertiga Cab",
    "One Way Ertiga Rental",
    "Round Trip Ertiga Rental",
    "Family Ertiga Cab",
    "Airport Drop",
    "Wedding Trip",
    "Tour Cab",
    "AC Ertiga Rental",
    "SUV Ertiga Rental"
  ],
  "additionalProperty": {
    "@type": "PropertyValue",
    "name": "Comfort",
    "value": "Comfortable and Affordable"
  }
};



    return (
        <div>
<Helmet>
  <title>Viman Nagar to Mumbai Ertiga On Rent | Affordable 7 Seater Ertiga Cab</title>
  <meta
    name="description"
    content="Book Viman Nagar to Mumbai Ertiga taxi services including one way, round trip, family cab, airport drop, wedding trips, and affordable AC Ertiga rental."
  />
  <meta
    name="keywords"
    content="Viman Nagar to Mumbai Ertiga Taxi, Ertiga Rental Viman Nagar to Mumbai, 7 Seater Ertiga Cab Viman Nagar, Ertiga One Way Viman Nagar to Mumbai, Viman Nagar to Mumbai Outstation Ertiga, Viman Nagar to Mumbai Round Trip Ertiga, Crysta Ertiga Viman Nagar to Mumbai, Viman Nagar to Mumbai Family Ertiga Cab, Ertiga for Airport Drop Viman Nagar, Viman Nagar to Mumbai Wedding Ertiga, Affordable Ertiga Viman Nagar to Mumbai, Viman Nagar to Mumbai AC Ertiga Rental, Viman Nagar to Mumbai Tour Cab Ertiga, Comfortable Ertiga Cab Viman Nagar to Mumbai, SUV Ertiga Rental Viman Nagar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Vimannagartomumbaiertigaonrent ;